import React from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { useFboOnboarding } from '../../../hooks/useFboOnboarding';

const SellerDashboardPage = () => {
  const { fbo, loading } = useFboOnboarding();

  if (loading) {
    return (
      <Container className="py-5">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row>
        <Col>
          <h1 className="mb-4">Seller Dashboard</h1>

          {fbo?.onboarding_stage === 'completed' && (
            <Alert variant="success" className="mb-4">
              <strong>Welcome to Kinn!</strong> Your account is now active. Start building your menu and setting up your shop.
            </Alert>
          )}

          <Row>
            <Col md={4} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title>Menu Management</Card.Title>
                  <Card.Text>
                    Create and manage your menu items, pricing, and descriptions.
                  </Card.Text>
                  <Button variant="primary">Manage Menu</Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title>Orders</Card.Title>
                  <Card.Text>
                    View incoming orders and manage fulfillment.
                  </Card.Text>
                  <Button variant="primary">View Orders</Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title>Analytics</Card.Title>
                  <Card.Text>
                    Track your sales performance and customer feedback.
                  </Card.Text>
                  <Button variant="primary">View Analytics</Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title>Training & Support</Card.Title>
                  <Card.Text>
                    Access training materials, compliance guides, and get help from our support team.
                  </Card.Text>
                  <Button variant="outline-primary">Get Support</Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title>Account Settings</Card.Title>
                  <Card.Text>
                    Update your profile, payment settings, and subscription details.
                  </Card.Text>
                  <Button variant="outline-primary">Manage Account</Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default SellerDashboardPage;
